import React from 'react';
import { NavLink } from 'react-router-dom';

const services = [
    {
        count: 1,
        title: 'أعمال الهياكل الخرسانية',
        flaticon: 'flaticon-city',
        description: 'أعمال الانشاءات الخرسانية والتي تشمل أعمال الأساسات والميدات ورقاب الأعمدة والجدران والأعمدة والبلاطات والطوب والحجر والسلالم وأنظمة السلامة',
    },
    {
        count: 2,
        title: 'أعمال التلييس والبلاط',
        flaticon: 'flaticon-paint',
        description: 'خدمة أعمال البلاط تشمل تقديم تصاميم مميزة ومبتكرة تواكب الأحدث في عالم الديكور للمشاريع البنائية، وتضيف لمشروعك الجمال والإبداع',
    },
    {
        count: 3,
        title: 'توريد وتركيب جميع أنواع الأبواب والنوافذ',
        flaticon: 'flaticon-crane',
        description: 'يشمل توريد وتركيب الأبواب والنوافذ بمختلف أنواعها مثل الأبواب الخشبية والمعدنية والزجاجية وابواب ونوافذ الالمونيوم pvc ذات جودة متميزة ومحكمة الاغلاق وتوفر العزل الصوتي والحراري ومانعة للتسرب',
    },
    {
        count: 4,
        title: 'أعمال الديكورات والدهانات',
        flaticon: 'flaticon-decorating',
        description: 'من الخدمات في هذا المجال التصميم الداخلي للمساحات السكنية والتجارية، وتركيب الأرضيات والجدران والأسقف وتركيب الديكورات والأثاث والإضاءة، وتنظيف وصيانة المساحات ونحن تستخدم مواد عالية الجودة نحن نعمل بشكل احترافي ومتميز ليليق بعميلنا',
    },
    {
        count: 5,
        title: 'أعمال الالكتروميكنيكال والأنظمة الأمنية وأنظمة السلامة',
        flaticon: 'flaticon-chart',
        description: 'وتشمل الأعمال الميكانيكية والكهربائية والصحية والأعمال الهندسية والتصاميم والتركيب وأنظمة تشغيل أجهزة التدفئة والتهوية وتكييف الهواء والتركيبات الصحية كافة الأعمال الكهربائية وأنظمة الامن والسلامة ونظم مكافحة الحرائق',
    },

]

var img1 = require('./../../images/background/bg-5.png');
var img2 = require('./../../images/background/line.png');

class OurServices3 extends React.Component {
    componentDidMount() {
        function loadScript(src) {

            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };

        loadScript('./assets/js/masonary.js');

    };
    render() {
        return (
            <>
                <div className="section-full p-t80 p-b50 bg-white mobile-page-padding" style={{ backgroundImage: 'url(' + img1 + ')' }}>
                    <div className="container">
                        <div className="section-head">
                            <div className="mt-separator-outer separator-center">
                                <div className="mt-separator">
                                    <h2 className="text-uppercase sep-line-one " style={{ fontFamily: 'Cairo, sans-serif', fontWeight: 'bold' }}>خدمـــــاتنا</h2>
                                </div>
                            </div>
                        </div>
                        <div className="section-content" >
                            <div className="row" >
                                {services.map((item, index) => (
                                    <div key={index} className="col-md-4 col-sm-6 d-flex" >
                                        <div className="mt-icon-box-wraper p-a30 center m-b30 box-shadow bg-white w-100 d-flex flex-column" style={{ height:'400px' }}>

                                            <div className="mt-icon-box-sm inline-icon text-primary  m-b20 radius bg-primary  scale-in-center bg-moving" style={{ backgroundImage: 'url(' + img2 + ')' }}>
                                                <span className="icon-cell text-secondry" ><i className={item.flaticon} /></span>
                                            </div>
                                            <div className="icon-content" >
                                                <h4 className="mt-tilte text-uppercase font-weight-600 m-b20" style={{ fontFamily: 'Cairo, sans-serif' }}>{item.title}</h4>
                                                <p style={{ fontFamily: 'Cairo, sans-serif' }}>{item.description}</p>
                                                <NavLink to={"/services"} className="site-button-link" data-hover="Read More" style={{ fontFamily: 'Cairo, sans-serif' }}>إقرأ المزيد <i className="fa fa-angle-right arrow-animation" /></NavLink>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default OurServices3;